import { FilterItem } from "@app/api/core/filter/filter-item";

export const getFilterItemFormErrors = (touchedField?: boolean | FilterItem, errorMessage?: string) => {
  if (touchedField === true || (touchedField && touchedField?.value === true)) {
    return errorMessage;
  }

  return undefined;
};
